import React, { useId, useState } from "react";
import "./TextInput.css";
import Invalid from "./img/invalid.svg";
import Hide from "./img/hide.svg";
import Show from "./img/show.svg";
import Text from "../text/Text";

export default function TextInput(props) {
  const {
    label,
    placeholder,
    setInput,
    input,
    name,
    type,
    error,
    errorMessage,
    setError,
    keyUp,
    setKeyUp,
    onChangeFunction,
    width,
    emailState,
    disable,
    showCharCount,
    maxLength,
    required = false,
  } = props;

  const generatedId = useId();
  const inputId = name ? `text-input-${name}` : generatedId;
  const errorId = `${inputId}-error`;
  const isPasswordField =
    type === "password" || label?.includes("Password");
  const [inputType, setInputType] = useState("password");

  const charCount = input?.[name]?.length || 0;

  const handleKeyUp = (e) => {
    if (e.key === "Enter") {
      setKeyUp(!keyUp);
    }
  };

  const showHide = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  const isTextarea = label?.includes("Message") || type === "textarea";

  const describedBy = error && errorMessage ? errorId : undefined;

  return (
    <div className="text-input-container">
      {label && (
        <label htmlFor={inputId} className="text-input-label">
          <Text
            size="0.875rem"
            color="#344054"
            weight="500"
            align="left"
            text={
              required ? (
                <>
                  {label}
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </>
              ) : (
                label
              )
            }
          />
        </label>
      )}
      <div className="text-input" style={{ width: width || "100%" }}>
        {isTextarea ? (
          <textarea
            id={inputId}
            className={`text-input-box ${error ? "error" : ""}`}
            style={{
              border: error
                ? "0.063rem solid #FDA29C"
                : "0.063rem solid #D0D5DD",
              width: width,
            }}
            placeholder={placeholder}
            disabled={disable}
            name={name}
            value={input?.[name] || ""}
            onChange={(e) => {
              onChangeFunction(e);
            }}
            onKeyUpCapture={handleKeyUp}
            aria-invalid={error ? true : undefined}
            aria-describedby={describedBy}
            aria-required={required || undefined}
          />
        ) : (
          <input
            id={inputId}
            className={`text-input-box ${error ? "error" : ""}`}
            style={{
              border: error
                ? "0.063rem solid #FDA29C"
                : "0.063rem solid #D0D5DD",
              width: width,
            }}
            type={isPasswordField ? inputType : type}
            placeholder={placeholder}
            disabled={disable}
            name={name}
            value={input?.[name] || ""}
            onChange={(e) => {
              onChangeFunction(e);
            }}
            onKeyUpCapture={handleKeyUp}
            autoComplete={type === "password" ? "new-password" : "on"}
            aria-invalid={error ? true : undefined}
            aria-describedby={describedBy}
            aria-required={required || undefined}
          />
        )}
        <img
          src={Invalid}
          className="iconnn-invalid"
          alt=""
          aria-hidden="true"
          style={{
            opacity: error ? 1 : 0,
            visibility: error ? "visible" : "hidden",
            transition: "opacity 0.1s ease, visibility 0.1s ease",
          }}
        />
        {isPasswordField && !error && (
          <button
            type="button"
            className="iconnn-show text-input-password-toggle"
            onClick={showHide}
            aria-label={
              inputType === "password" ? "Show password" : "Hide password"
            }
            aria-pressed={inputType !== "password"}
          >
            {inputType === "password" ? (
              <img src={Hide} alt="" aria-hidden="true" />
            ) : (
              <img src={Show} alt="" aria-hidden="true" />
            )}
          </button>
        )}
      </div>
      <p
        id={errorId}
        className={`text-input-error-message${error ? " visible" : ""}`}
        role={error ? "alert" : undefined}
        aria-hidden={!error}
        style={{
          opacity: error ? 1 : 0,
          transition: "opacity 0.1s ease-out",
        }}
      >
        {errorMessage}
      </p>
      {showCharCount && (
        <div className="text-input-char-count">
          {charCount} / {maxLength}
        </div>
      )}
    </div>
  );
}
